/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".ui-select-container.ui-select-bootstrap{display:inline-block;width:50%}.ui-select-container .form-control{width:100%}.national-network-warning-container{padding-top:15px}.national-network-warning-icon{font-size:20px;margin-top:5px;margin-right:5px}.national-network-warning-text{font-size:12px;overflow:hidden}.national-network-warning-label{width:100%}\n/*# sourceMappingURL=routing-profile-detail.component.css.map*/"];
export { styles as styles };
